import React, { useState } from 'react'
import BasicDetails from './BasicDetails'
import AddressDetails from './AddressDetails'
import BankDetails from './BankDetails'
export default function Main({ handlePage, Detaildata,ParentcommId}) {
    const [tab, setTab] = useState("basic")
    // const [tab, setTab] = useState("breconfig")
    const [communityId, setcommunityId] = useState("")

    const handleTabs = (type) => {
        setTab(type)
    }

    const commId =(id)=>{
        setcommunityId(id)
    }

    return (
        <>
            {
                tab === "basic" ?
                    <BasicDetails handleTabs={handleTabs} handlePage={handlePage} commId={commId} Detaildata={Detaildata} ParentcommId={ParentcommId}/>
                    : ''}
            {
                tab === "address" ?
                    <AddressDetails handleTabs={handleTabs} handlePage={handlePage} communityId={communityId} Detaildata={Detaildata}/>
                    : ''}
            {
                tab === "bank" ?
                    <BankDetails handleTabs={handleTabs} handlePage={handlePage} communityId={communityId} Detaildata={Detaildata}/>
                    : ''}
            
        </>
    )
}
